// 页面样式
import css from 'css/page/news.scss'
// 公共方法
import {
  domObserver,
  headerInit,
  memberShip,
} from 'js/common/index'

/**
 * 绑定 DOM 事件
 */
function bindEvts () {
  memberFormInit()
}

function memberFormInit() {
  memberShip.closeForm.init()
  memberShip.forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member',
  })
  memberShip.loginFormInit({
    success: () => headerInit(),
    form: '.yui-memberform0-login',
    mask: '.mask-member',
  })
  memberShip.registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member',
  })
}

/**
 * 排行榜初始化
 */
function rankListInit () {
  $('.yui-cranklist0').on('mouseenter', 'li', function () {
    $(this).addClass('selected').siblings('.selected').removeClass('selected')
  })
}

/**
 * UI 初始化
 */
function uiInit () {
  rankListInit()
}

window._dataBus.get('domReadyObserver').subscribe(() => {
  uiInit()
  bindEvts()
})



// WEBPACK FOOTER //
// ./js/page/news.js